import { DynamicFeed } from "@material-ui/icons";
import PageLayout from "../../../common/layouts/pageLayout";
import FollowupForm, { FollowUpFormPayload } from "./followupForm/followupForm";
import { Container, Grid, makeStyles } from "@material-ui/core";
import StyledFormTitle from "../../../common/components/typographies/StyledFormTitle";
import { useCreateFollowUpAssessoria } from "./hooks/useCreateFollowupAssessoria";
import { FollowUp } from "../../../common/types/followUp";
import { MediaType } from "../../../../utils/api/api-utils";
import { useHistory } from "react-router";
import { useQueryClient } from "react-query";
import { QueriesTypes } from "../../../common/hooks/queries";
import { setErrorFeedback } from "../../../../features/feedback/feedbackSlice";
import { useDispatch } from "react-redux";

type Props = {};

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    padding: "0 1rem 3rem 1rem",
  },
}));

function NewAssessoriaFollowupPage({}: Props) {
  const classes = useStyles();

  const history = useHistory();
  const dispatch = useDispatch<any>();


  const client = useQueryClient();

  function postSubmit(payload: any) {
    client.invalidateQueries(QueriesTypes.FollowUpsFilter);
    history.push(`/assessoria/followup?code=${payload.numero}`);
  }

  const [createFollowUp] = useCreateFollowUpAssessoria({
    onSettled: ({ data, error }) => {
      if (error && error.status === 303) {
        dispatch(
          setErrorFeedback({
            message: "Este FollowUp já foi cadastrado anteriormente.",
          })
        );
        return;
      }
      if (data) {
        postSubmit(data);
      }
    },
  });
  

  function handleSubmit(followUp: FollowUpFormPayload) {
    const formData = new FormData();

    const json = JSON.stringify(followUp);
    const blob = new Blob([json], {
      type: MediaType.APPLICATION_JSON,
    });

    formData.append("data", blob);

    const meta = { metadata: [] };
    const jsonMeta = JSON.stringify(meta);
    const blobMeta = new Blob([jsonMeta], {
      type: MediaType.APPLICATION_JSON,
    });

    formData.append("metadata", blobMeta);

    createFollowUp({ requestFormData: formData });
  }

  return (
    <PageLayout
      title={"Novo Registo de FollowUp"}
      icon={<DynamicFeed color={"secondary"} />}
    >
      <Container className={classes.container}>
        <Grid container style={{ marginTop: "0.2rem" }}>
          <Grid item xs={12} style={{ marginBottom: "1.4rem" }}>
            <StyledFormTitle title="Preencha os campos abaixo:" />
          </Grid>
          <FollowupForm submitCallback={handleSubmit}></FollowupForm>
        </Grid>
      </Container>
    </PageLayout>
  );
}

export default NewAssessoriaFollowupPage;
